export default "__VITE_ASSET__BCLmFzy1__"